import React, { Fragment } from "react";
import Countdown, { doubleDigit } from "react-downcount";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';

const endDate = new Date("2020-11-28");

const customRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
  return !isCompleted ? (
    <Fragment>
      <div className="segment">
        <span className="number">{days}</span>
        <span className="unit">days</span>
      </div>
      <div className="segment">
        <span className="number">{hrs}</span>
        <span className="unit">hours</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(mins)}</span>
        <span className="unit">min</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(secs)}</span>
        <span className="unit">sec</span>
      </div>
    </Fragment>
  ) : null;
};

class Hero extends React.Component {
  // goRegister() {
  //   // return;
  //   const target = document.getElementById("register");
  //   target.scrollIntoView({ block: "start", behavior: "smooth" });
  // }

  goToRegist() {
    window.open(this.props.Message.registerURL)
  }

  render() {
    const { isSG, Message: msg } = this.props;
    
    return (
      <section id="hero">
        <div className="container">
          <img
            src={require('@ndsc/assets/images/hero-image-2020.png')}
            alt="National Data Science Challenge logo"
            className="hero-image"
          />
          <ReactWOW animation="fadeInUp" delay="0.1s">
            <p className="date">{$t(msg.dateRange)}</p>
            {
              !isSG
              ? <Countdown className="countdown" endDate={endDate}>
                  {customRenderer}
                </Countdown>
              : <div></div>
            }
            <h1 dangerouslySetInnerHTML={{ __html: $t(msg.heroDesc) }} />
            {/* <button
              title={msg.registerNow}
              onClick={this.goRegister}
              className="btn btn-primary"
            >
              {msg.registerClose}
            </button> */}
            <button className="btn btn-primary" onClick={() => this.goToRegist()} disabled type="button" >{$t(msg.registerClose)}</button>
          </ReactWOW>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </section>
    );
  }
}

export default Hero;
